



































import { Vue, Prop, PropSync, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';

export interface CandidateDataItem {
  name: string;
  value: any;
}

interface SearchedResultItem {
  name: string;
  value: any;
  labelInUl: string;
}

/**
 * input에 입력한 값을 name으로 포함하고 있는 candidateDataItem을 리스트로 띄워줍니다.
 * 그 중에 하나를 선택하면 해당 candidateDataItem의 value를 부모에게 value 값으로 넘깁니다.
 */
@Component({})
export default class AutoSearchInput extends Vue {
  @PropSync('value')
  private valueSync!: any;
  @Prop({required: true})
  private readonly candidateDataList!: CandidateDataItem[];
  @Prop( {required: false, default: ''})
  private readonly inputPlaceholder!: string;
  @Prop({required: false, default: 'The candidateDataList is empty (component: AutoSearchInput)'})
  private readonly msgForAlertItIsNotAvailable!: string;
  @Prop({required: false, default: '(No results)'})
  private readonly msgForNoSearchedResult!: string;

  private inputValue = '';
  private isSearchedResultUlVisible = false;
  private searchResultLiIdx = -1;
  private searchedResultList: SearchedResultItem[] = [];

  private get isAvailable(): boolean {
    return this.candidateDataList.length !== 0;
  }

  private mounted() {
    // 유효한 value가 있는 채로 들어온다면 해당 value에 맞는 name을 inputValue에 할당하여 화면 출력
    this.updateInputValue();
  }

  @Watch('valueSync')
  private updateInputValue(): void {
    const pairNameOfValue = this.candidateDataList
        .find(candidateData => candidateData.value === this.valueSync)
        ?.name
    if (pairNameOfValue === this.inputValue) return ;
    this.inputValue = pairNameOfValue ?? '';
  }

  private handleInputFocus(e: Event): void {
    if (!this.isAvailable) {
      const $inputEl = e.currentTarget as HTMLInputElement;

      alert(this.msgForAlertItIsNotAvailable)
      $inputEl.blur();
      return ;
    }
    this.search();
    this.isSearchedResultUlVisible = true;
  }

  private handleInputChange(): void {
    this.search();
    this.isSearchedResultUlVisible = true;
    this.searchResultLiIdx = -1;
  }

  private handleLiClick(clickedItem: SearchedResultItem): void {
    this.isSearchedResultUlVisible = false;
    this.inputValue = clickedItem.name;
    this.confirmValue(clickedItem.value);
    this.searchResultLiIdx = -1;
  }

  private handleInputKeyPressUp(): void {
    // keydown 이벤트 두 번 눌리는 이슈가 있습니다. (https://github.com/vuejs/vue/issues/10277)
    if (this.searchResultLiIdx <= 0) {
      this.searchResultLiIdx = this.searchedResultList.length - 1;
      return;
    }
    this.searchResultLiIdx--;
  }

  private handleInputKeyPressDown(): void {
    // keydown 이벤트 두 번 눌리는 이슈가 있습니다. (https://github.com/vuejs/vue/issues/10277)
    if (this.searchResultLiIdx < this.searchedResultList.length - 1) {
      this.searchResultLiIdx++;
    } else {
      this.searchResultLiIdx = 0;
    }
  }

  private handleInputPressEnter(): void {
    if (this.searchResultLiIdx === -1) return;

    const selectedItem = this.searchedResultList[this.searchResultLiIdx];
    this.isSearchedResultUlVisible = false;
    this.inputValue = selectedItem.name;
    this.confirmValue(selectedItem.value);
    this.searchResultLiIdx = -1;
  }

  private handleInputBlur(): void {
    if (!this.searchedResultList.find(item => item.name === this.inputValue)) {
      this.inputValue = '';
    }
    this.isSearchedResultUlVisible = false;
    this.searchResultLiIdx = -1;
  }

  private search(): void {
    // 문자의 대소구분 없이 this.inputValue 값을 찾는 정규표현식
    const reg = new RegExp(this.inputValue, 'gi');

    // 정규표현식으로 찾아진 문자열들에게 배경색 입히기
    const highlightWordAll = (string: string, reg: RegExp): string => {
      return string.replace(reg, (match) => `<span>${match}</span>`);
    }

    this.searchedResultList = this.candidateDataList
        .reduce((acc: SearchedResultItem[], curr: CandidateDataItem): SearchedResultItem[] => {
          if (reg.test(curr.name)) {
            const result: SearchedResultItem = {} as SearchedResultItem;
            result.name = curr.name;
            result.value = curr.value;
            result.labelInUl = this.inputValue ? highlightWordAll(curr.name, reg) : curr.name;
            acc.push(result);
          }
          return acc;
        }, [])
  }

  private confirmValue(selectedValue: any): void {
    this.valueSync = selectedValue;
    this.$emit('change', selectedValue);
  }
}
